export const ReportConstants = {
    TEXT_REWRITE: 'enable-text-rewrite-on-report',
};
export const ReportConstantsTracks = {
    HELPDESK_REPORTS_DATAEXTRACTOR_BUTTON: 'helpdesk-reports-dataextractor-button',
    HELPDESK_REPORTS_DATAEXTRACTOR_MODAL: 'helpdesk-reports-dataextractor-modal',
    HELPDESK_REPORTS_DATAEXTRACTOR_MODAL_CLOSE: 'helpdesk-reports-dataextractor-modal-close',
};
